import { TModel } from "Shared/models/t-model";

export class Suggestion extends TModel {
  Id: number;
  RequestId: string;
  FirstName: string;
  LastName: string;
  IsCitizen: boolean;
  IsResident?: boolean;
  DateOfBirth: string;
  SuggestionSubject: string;
  SuggestionDetails: string;
  AttachmentId?: string;
  IsCorrectInformation: boolean;
  DecisionAr: string;
  DecisionEn: string;
  DecisionId?:number;
  EmployeeComment: string;
  IsAnonymous: boolean;
  ReCaptchaResopnse: string;
  PreferredCommunication: number;
  SuggestionTitle: string;
}
